import { useBaseStore } from '@/store';
import { Store } from '@/store/type';
import { useEffect } from 'react';

const MOBILE_WIDTH = 768;
const TABLET_WIDTH = 1440;
const TABLET_HEIGHT = 600;

const stateSelector = (state: Store) => ({
  setIsMobile: state.appConfigSlice.actions.setIsMoble,
});

export const checkIsMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;

  const width = window.innerWidth;
  const height = window.innerHeight;

  const isMobile = width < MOBILE_WIDTH;
  const isTablet = width <= TABLET_WIDTH && height >= TABLET_HEIGHT;

  return isMobile || isTablet;
};

export const useCheckMobile = () => {
  const { setIsMobile } = useBaseStore(stateSelector);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(checkIsMobileDevice());
    };

    updateIsMobile();

    window.addEventListener('resize', updateIsMobile);
    window.addEventListener('orientationchange', updateIsMobile);

    return () => {
      window.removeEventListener('resize', updateIsMobile);
      window.removeEventListener('orientationchange', updateIsMobile);
    };
  }, [setIsMobile]);
};
